import SideBarActions from '@/view/sidebar/store-module/utility';

const actions = {
    [SideBarActions.TOGGLE_SIDEBAR]: ({state, commit}: any) => {
        if (state.sideBarVisible === true) {
            commit(SideBarActions.HIDE_SIDEBAR);
        } else {
            commit(SideBarActions.SHOW_SIDEBAR);
        }
    },
};

export default {
    actions,
};
